import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const AdminDashboard = () => import('@/views/AdminDashboard')

const HelpCenter = () => import('@/views/help/HelpCenter')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/Charts')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

const Stores = () => import('@/views/stores/Stores')

const Campaigns = () => import('@/views/campaigns/Campaigns')

const Entities = () => import('@/views/entities/Entities')

const Bots = () => import('@/views/bots/Bots')

const Newsletters = () => import('@/views/newsletters/Newsletters')

const Workspaces = () => import('@/views/workspaces/Workspaces')

const Websites = () => import('@/views/websites/Websites')

const SocialAccounts = () => import('@/views/social/SocialAccounts')

const MailBoxes = () => import('@/views/mailboxes/MailBoxes')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const Account = () => import('@/views/pages/Account')

const Packages = () => import('@/views/pages/Packages')


const RequestDelete = () => import('@/views/pages/RequestDelete')

const RegisterKe = () => import('@/views/pages/RegisterKe')

// Users

// new items


const Store = () => import('@/views/stores/Store')

const Privacy = () => import('@/views/pages/Privacy')

const Storev1 = () => import('@/views/stores/Storev1')

const Campaign = () => import('@/views/campaigns/Campaign')

const Entity = () => import('@/views/entities/Entity')

const Bot = () => import('@/views/bots/Bot')


const Newsletter = () => import('@/views/newsletters/Newsletter')


const Workspace = () => import('@/views/workspaces/Workspace')


const RegistrationSuccess = () => import('@/views/pages/RegistrationSuccess')




Vue.use(Router)

const router =  new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: Privacy
    },
    {
      path: '/request_delete',
      name: 'DeleteRequest',
      component: RequestDelete
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/success',
      name: 'Success',
      component: RegistrationSuccess
    },
    {
      path: '/packages',
      name: 'packages',
      component: Packages
    },
    {
      path: '/register-ke',
      name: 'RegisterKe',
      component: RegisterKe
    },
    {
      path: '/',
      redirect: '/users/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'users/dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'users/dashboard/stores',
          name: 'Stores',
          component: Stores
        },
        {
          path: 'users/dashboard/stores/:id',
          name: 'Store',
          component: Store
        },
        {
          path: 'users/dashboard/storesv1/:id',
          name: 'Storev1',
          component: Storev1
        },
        {
          path: 'users/dashboard/help',
          name: 'HelpCenter',
          component: HelpCenter
        },
        {
          path: 'users/dashboard/campaigns',
          name: 'Campaigns',
          component: Campaigns
        },
        {
          path: 'users/dashboard/entities',
          name: 'Entities',
          component: Entities
        },
        {
          path: 'users/dashboard/campaigns/:id',
          name: 'Campaign',
          component: Campaign
        },
        {
          path: 'users/dashboard/entities/:id',
          name: 'Entity',
          component: Entity
        },
        {
          path: 'users/dashboard/bots/:id',
          name: 'Bot',
          component: Bot
        },
        {
          path: 'users/dashboard/newsletters/:id',
          name: 'Newsletter',
          component: Newsletter
        },
        {
          path: 'users/dashboard/websites',
          name: 'Websites',
          component: Websites
        },
        {
          path: 'users/dashboard/social',
          name: 'Social Accounts',
          component: SocialAccounts
        },
        {
          path: 'users/dashboard/bots',
          name: 'Bots',
          component: Bots
        },
        {
          path: 'users/dashboard/mailboxes',
          name: 'MailBoxes',
          component: MailBoxes
        },
        {
          path: 'users/dashboard/billing',
          name: 'Billing',
          component: Account
        },
        {
          path: 'users/dashboard/newsletters',
          name: 'Newsletters',
          component: Newsletters
        },

        {
          path: 'users/dashboard/workspaces',
          name: 'Workspaces',
          component: Workspaces
        },
        {
          path: 'users/dashboard/workspaces/:id',
          name: 'Workspace',
          component: Workspace
        },

      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
});


export default router;
